import React from 'react';
import Link from 'next/link';

function CareerLiftLogo() {
  return (
    <div className="flex items-center gap-2.5">
      <svg width="26" height="26" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
        <rect width="32" height="32" rx="8" fill="#2563eb" />
        <path d="M7 21L12 11L17 16L21 10" stroke="white" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"/>
        <circle cx="21" cy="10" r="2.5" fill="white"/>
        <path d="M7 25h18" stroke="rgba(255,255,255,0.4)" strokeWidth="1.5" strokeLinecap="round"/>
      </svg>
      <span className="text-sm font-bold tracking-tight text-slate-800">
        Career<span className="text-blue-600">Lift</span>
      </span>
    </div>
  );
}

export default function Footer() {
  return (
    <footer className="border-t border-blue-100 bg-white pb-safe">
      <div className="max-w-7xl mx-auto px-6 py-12">
        <div className="flex flex-col md:flex-row items-start md:items-start justify-between gap-10">
          {/* Brand */}
          <div className="flex flex-col gap-3 max-w-xs">
            <Link href="/" aria-label="CareerLift home">
              <CareerLiftLogo />
            </Link>
            <p className="text-sm text-slate-500 leading-relaxed">
              AI-powered career tools for the modern job seeker. Build your resume, find scholarships, and grow your career.
            </p>
          </div>

          {/* Links */}
          <div className="flex flex-wrap gap-x-12 gap-y-6">
            <div className="flex flex-col gap-2.5">
              <span className="text-xs font-bold text-slate-800 uppercase tracking-wider">Tools</span>
              <Link href="/resume-builder" className="text-sm text-slate-500 hover:text-blue-600 transition-colors">Resume Builder</Link>
              <Link href="/scholarships" className="text-sm text-slate-500 hover:text-blue-600 transition-colors">Scholarships</Link>
              <Link href="/career-search" className="text-sm text-slate-500 hover:text-blue-600 transition-colors">Career Search</Link>
              <Link href="/video-templates" className="text-sm text-slate-500 hover:text-blue-600 transition-colors">Video Templates</Link>
              <Link href="/ats-analyzer" className="text-sm text-slate-500 hover:text-blue-600 transition-colors">ATS Analyzer</Link>
              <Link href="/job-analyzer" className="text-sm text-slate-500 hover:text-blue-600 transition-colors">Job Analyzer</Link>
            </div>
            <div className="flex flex-col gap-2.5">
              <span className="text-xs font-bold text-slate-800 uppercase tracking-wider">Account</span>
              <Link href="/login" className="text-sm text-slate-500 hover:text-blue-600 transition-colors">Sign In</Link>
              <Link href="/register" className="text-sm text-slate-500 hover:text-blue-600 transition-colors">Create Account</Link>
              <Link href="/dashboard" className="text-sm text-slate-500 hover:text-blue-600 transition-colors">Dashboard</Link>
              <Link href="/account-settings" className="text-sm text-slate-500 hover:text-blue-600 transition-colors">Account Settings</Link>
              <Link href="/pricing" className="text-sm text-slate-500 hover:text-blue-600 transition-colors">Pricing</Link>
            </div>
            <div className="flex flex-col gap-2.5">
              <span className="text-xs font-bold text-slate-800 uppercase tracking-wider">Legal</span>
              <Link href="/privacy" className="text-sm text-slate-500 hover:text-blue-600 transition-colors">Privacy Policy</Link>
              <Link href="/terms" className="text-sm text-slate-500 hover:text-blue-600 transition-colors">Terms of Service</Link>
              <Link href="/data-privacy" className="text-sm text-slate-500 hover:text-blue-600 transition-colors">Data &amp; Privacy</Link>
            </div>
          </div>
        </div>

        <div className="mt-10 pt-6 flex flex-col sm:flex-row items-center justify-between gap-3 border-t border-blue-50">
          <p className="text-xs text-slate-400">© 2026 CareerLift. All rights reserved.</p>
          <div className="flex items-center gap-5 text-xs text-slate-400">
            <Link href="/privacy" className="hover:text-blue-600 transition-colors">Privacy Policy</Link>
            <Link href="/terms" className="hover:text-blue-600 transition-colors">Terms of Service</Link>
            <Link href="/data-privacy" className="hover:text-blue-600 transition-colors">Data &amp; Privacy</Link>
          </div>
        </div>
      </div>
    </footer>
  );
}